import { NavigationGuardNext, Route } from 'vue-router'
import dayjs from 'dayjs'
import store from '@/store'
import StorageService from '@/services/storage-service'

function authGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const isAuthenticated = store.getters['auth/isAuthenticated']
  if (!isAuthenticated) {
    StorageService.setItem('okmenu_route_after_auth', { path: to.path, query: to.query }, dayjs().add(1, 'hour').toDate(), -1)
    return next({ name: 'login', query: to.query, hash: '#redirected' })
  }

  if (to.meta.redirectIfLoggedIn && isAuthenticated) return next()
  return next()
}

export default authGuard
